// Route removed completely. Private route remains. Home the default. Access to dashboard only when logged in.
import React from "react";
import { Routes, Route } from "react-router-dom";

import SharedLayout from "./pages/Dashboard/SharedLayout";
// import AdminApplication from "./pages/Dashboard/ApplicationsPage/AdminApp/AdminApplication";
import Application from "./pages/Dashboard/ApplicationsPage/AnalystApp/Applications";
import Models from "./pages/Dashboard/Models";
// import Settings from "./pages/Dashboard/SettingsPage/Settings";
import AdminSettingsPage from "./pages/Dashboard/SettingsPage/AdminSettingsPage";
import Teams from "./pages/Dashboard/TeamsPage/Teams";
import Dashboard from "./pages/Dashboard/Dashboard/Dashboard";
import Faq from "./pages/Dashboard/Faq/Faq";
import Chat from "./pages/Dashboard/Chat/Chat";
import Logout from "./pages/Dashboard/Logout";
import SignUpPage from "./pages/Onboarding/SignUpPage";
import CreateModelStep1 from "./pages/CreateModel/CreateModelStep1";
import CreateModelStep2 from "./pages/CreateModel/CreateModelStep2";
import CreateModelStep3 from "./pages/CreateModel/CreateModelStep3";
import CreateModelStep5 from "./pages/CreateModel/CreateModelStep5";
import ProfilePage from "./pages/CustomerProfile/ProfilePage";
import Login from "./components/signUpForm/Login";
import PersonalDetails from "./components/signUpForm/PersonalDetails";
import CreateModelStep4 from "./pages/CreateModel/CreateModelStep4";
import ForgotPassword from "./components/signUpForm/ForgotPassword";
import Home from "./pages/Onboarding/Home";
import AddTeam from "./components/signUpForm/AddTeam";
import SuccessfulPassword from "./components/signUpForm/SuccessfulPassword";
import PasswordResetNotification from "./components/signUpForm/PasswordResetNotification";
import ResetPassword from "./components/signUpForm/ResetPassword";
import UploadLogo from "./components/signUpForm/UploadLogo";
import ContinueAddTeam from "./components/signUpForm/ContinueAddTeam";
import VerifyEmail from "./components/signUpForm/VerifyEmail";
import VerificationMsg from "./components/signUpForm/VerificationMsg";
import UserSetup from "./components/signUpForm/UserSetup";
import CreateModelStep3_0 from "./pages/CreateModel/CreateModelStep3_0";
import SuccessfulModal from "./pages/Dashboard/TeamsPage/SuccessfulModal";
import ChangePassword from "./pages/Dashboard/SettingsPage/ChangePassword";

function App() {
  const privateRoutes = [
    {
      path: "profile/:applicantId",
      element: <ProfilePage />,
    },

    {
      path: "applications",
      element: <Application />,
    },
    {
      path: "models",
      element: <Models />,
    },

    {
      path: "settings",
      element: <AdminSettingsPage />,
    },
    {
      path: "teams",
      element: <Teams />,
    },
    {
      path: "faq",
      element: <Faq />,
    },
    {
      path: "chat",
      element: <Chat />,
    },
    {
      path: "logout",
      element: <Logout />,
    },
  ];

  return (
    <div className="font-inter">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUpPage />} />
        <Route path="/addTeam/:id" element={<AddTeam />} />
        <Route path="/details/:id" element={<PersonalDetails />} />
        <Route path="/forgotPassword" element={<ForgotPassword />} />
        <Route path="/resetNotification" element={<PasswordResetNotification />} />
        <Route path="/successfulPassword" element={<SuccessfulPassword />} />
        <Route path="/resetPassword" element={<ResetPassword />} />
        <Route path="/uploadLogo" element={<UploadLogo />} />
        <Route path="/continueTeam" element={<ContinueAddTeam />} />
        <Route path="/verifyEmail" element={<VerifyEmail />} />
        <Route path="/email_verification_message" element={<VerificationMsg />} />
        <Route path="/userSetup" element={<UserSetup />} />
        <Route path="/changePassword" element={<ChangePassword />} />
        <Route path="/successfulModal" element={<SuccessfulModal />} />

        <Route path="/dashboard/*" element={<SharedLayout />}>
          <Route index element={<Dashboard />} />

          {privateRoutes.map((route, index) => (
            <Route key={index} path={route.path} element={route.element} />
          ))}
        </Route>

        <Route path="createmodelstep1" element={<CreateModelStep1 />} />
        <Route path="createmodelstep2" element={<CreateModelStep2 />} />
        <Route path="createmodelstep3_0" element={<CreateModelStep3_0 />} />
        <Route path="createmodelstep3" element={<CreateModelStep3 />} />
        <Route path="createmodelstep4" element={<CreateModelStep4 />} />
        <Route path="createmodelstep5" element={<CreateModelStep5 />} />
      </Routes>
    </div>
  );
}

export default App;


// Trying admin and analyst logged in to view their pages.
// import React, { useEffect, useState } from "react";
// import { Routes, Route, Navigate, useLocation } from "react-router-dom";
// import "./App.css";
// import SharedLayout from "./pages/Dashboard/SharedLayout";
// import AdminApplication from "./pages/Dashboard/ApplicationsPage/AdminApp/AdminApplication";
// import Models from "./pages/Dashboard/Models";
// import Teams from "./pages/Dashboard/TeamsPage/Teams";
// import Dashboard from "./pages/Dashboard/Dashboard/Dashboard";
// import Faq from "./pages/Dashboard/Faq/Faq";
// import Chat from "./pages/Dashboard/Chat/Chat";
// import SignUpPage from "./pages/Onboarding/SignUpPage";
// import CreateModelStep1 from "./pages/CreateModel/CreateModelStep1";
// import CreateModelStep2 from "./pages/CreateModel/CreateModelStep2";
// import CreateModelStep3 from "./pages/CreateModel/CreateModelStep3";
// import CreateModelStep5 from "./pages/CreateModel/CreateModelStep5";
// import ProfilePage from "./pages/CustomerProfile/ProfilePage";
// import RouteGuard from "./components/RouteGuard";
// import Login from "./components/signUpForm/Login";
// import PersonalDetails from "./components/signUpForm/PersonalDetails";
// import CreateModelStep4 from "./pages/CreateModel/CreateModelStep4";
// import ForgotPassword from "./components/signUpForm/ForgotPassword";
// import Home from "./pages/Onboarding/Home";
// import AddTeam from "./components/signUpForm/AddTeam";
// import SuccessfulPassword from "./components/signUpForm/SuccessfulPassword";
// import PasswordResetNotification from "./components/signUpForm/PasswordResetNotification";
// import ResetPassword from "./components/signUpForm/ResetPassword";
// import UploadLogo from "./components/signUpForm/UploadLogo";
// import ContinueAddTeam from "./components/signUpForm/ContinueAddTeam";
// import VerifyEmail from "./components/signUpForm/VerifyEmail";
// import VerificationMsg from "./components/signUpForm/VerificationMsg";
// import UserSetup from "./components/signUpForm/UserSetup";
// import CreateModelStep3_0 from "./pages/CreateModel/CreateModelStep3_0";
// import AdminSettingsPage from "./pages/Dashboard/Settings/AdminSettingsPage";
// import AnalystSettingsPage from "./pages/Dashboard/Settings/AnalystSettingsPage";

// function App() {
//   const privateRoute = [
//     {
//       path: "/dashboard",
//       index: true,
//       component: <Dashboard />,
//     },
//     {
//       path: "/dashboard/profile/:applicantId",
//       component: (
//         <SharedLayout>
//           <RouteGuard>
//             <ProfilePage />
//           </RouteGuard>
//         </SharedLayout>
//       ),
//     },
//     {
//       path: "/dashboard/applications",
//       component: <AdminApplication />,
//     },
//     {
//       path: "/dashboard/models",
//       component: <Models />,
//     },
//     {
//       path: "/dashboard/settings",
//       component: <AdminSettingsPage />,
//       adminOnly: true,
//     },
//     {
//       path: "/dashboard/settings/analyst",
//       component: <AnalystSettingsPage />,
//       analystOnly: true,
//     },
//     {
//       path: "/dashboard/teams",
//       component: <Teams />
//     },
//     {
//       path: "/dashboard/faq",
//       component: <Faq />,
//     },
//     {
//       path: "/dashboard/chat",
//       component: <Chat />,
//     },
//   ];

//   return (
//     <div className="font-inter">
//       <Routes>
//         <Route path="/" element={<Home />} />
//         <Route path="/login" element={<Login />} />
//         <Route path="/signup" element={<SignUpPage />} />
//         <Route path="/addTeam/:id" element={<AddTeam />} />
//         <Route path="/details/:id" element={<PersonalDetails />} />
//         <Route path="/forgotPassword" element={<ForgotPassword />} />
//         <Route path="/resetNotification" element={<PasswordResetNotification />} />
//         <Route path="/successfulPassword" element={<SuccessfulPassword />} />
//         <Route path="/resetPassword" element={<ResetPassword />} />
//         <Route path="/uploadLogo" element={<UploadLogo />} />
//         <Route path="/continueTeam" element={<ContinueAddTeam />} />
//         <Route path="/verifyEmail" element={<VerifyEmail />} />
//         <Route path="/email_verification_message" element={<VerificationMsg />} />
//         <Route path="/userSetup" element={<UserSetup />} />

//         <Route path="/dashboard" element={<SharedLayout />}>
//           {privateRoute.map((route, index) => (
//             <Route
//               key={index}
//               path={route.path}
//               element={<RouteGuard>{route.component}</RouteGuard>}
//               index={index}
//             />
//           ))}
//           <Route path="createmodelstep1" element={<CreateModelStep1 />} />
//           <Route path="createmodelstep2" element={<CreateModelStep2 />} />
//           <Route path="createmodelstep3_0" element={<CreateModelStep3_0 />} />
//           <Route path="createmodelstep3" element={<CreateModelStep3 />} />
//           <Route path="createmodelstep4" element={<CreateModelStep4 />} />
//           <Route path="createmodelstep5" element={<CreateModelStep5 />} />
//         </Route>
//       </Routes>
//     </div>
//   );
// }

// export default App;

// fall back - new logic protected dashboard route
// import React, { useEffect, useState } from "react";
// import { Routes, Route, Navigate, useLocation } from "react-router-dom";
// import "./App.css";
// import SharedLayout from "./pages/Dashboard/SharedLayout";
// import AdminApplication from "./pages/Dashboard/ApplicationsPage/AdminApp/AdminApplication";
// import Models from "./pages/Dashboard/Models";
// import Settings from "./pages/Dashboard/Settings";
// import Teams from "./pages/Dashboard/TeamsPage/Teams";
// import Dashboard from "./pages/Dashboard/Dashboard/Dashboard";
// import Faq from "./pages/Dashboard/Faq/Faq";
// import Chat from "./pages/Dashboard/Chat/Chat";
// import SignUpPage from "./pages/Onboarding/SignUpPage";
// import CreateModelStep1 from "./pages/CreateModel/CreateModelStep1";
// import CreateModelStep2 from "./pages/CreateModel/CreateModelStep2";
// import CreateModelStep3 from "./pages/CreateModel/CreateModelStep3";
// import CreateModelStep5 from "./pages/CreateModel/CreateModelStep5";
// import ProfilePage from "./pages/CustomerProfile/ProfilePage";
// import RouteGuard from "./components/RouteGuard";
// import Login from "./components/signUpForm/Login";
// import PersonalDetails from "./components/signUpForm/PersonalDetails";
// import CreateModelStep4 from "./pages/CreateModel/CreateModelStep4";
// import ForgotPassword from "./components/signUpForm/ForgotPassword";
// import Home from "./pages/Onboarding/Home";
// import AddTeam from "./components/signUpForm/AddTeam";
// import SuccessfulPassword from "./components/signUpForm/SuccessfulPassword";
// import PasswordResetNotification from "./components/signUpForm/PasswordResetNotification";
// import ResetPassword from "./components/signUpForm/ResetPassword";
// import UploadLogo from "./components/signUpForm/UploadLogo";
// import ContinueAddTeam from "./components/signUpForm/ContinueAddTeam";
// import VerifyEmail from "./components/signUpForm/VerifyEmail";
// import VerificationMsg from "./components/signUpForm/VerificationMsg";
// import UserSetup from "./components/signUpForm/UserSetup";
// import CreateModelStep3_0 from "./pages/CreateModel/CreateModelStep3_0";

// function App() {
//   const privateRoute = [
//     {
//       path: "/dashboard",
//       index: true,
//       component: <Dashboard />,
//     },
//     {
//       path: "/dashboard/profile/:applicantId", // Corrected nested route path
//       component: (
//         <SharedLayout>
//           <RouteGuard>
//             <ProfilePage />
//           </RouteGuard>
//         </SharedLayout>
//       ),
//     },
//     {
//       path: "/dashboard/applications", // Corrected nested route path
//       component: <AdminApplication />,
//     },
//     {
//       path: "/dashboard/models", // Corrected nested route path
//       component: <Models />,
//     },
//     {
//       path: "/dashboard/settings", // Corrected nested route path
//       component: <Settings />,
//     },
//     {
//       path: "/dashboard/teams", // Corrected nested route path
//       component: <Teams />,
//     },
//     {
//       path: "/dashboard/faq", // Corrected nested route path
//       component: <Faq />,
//     },
//     {
//       path: "/dashboard/chat", // Corrected nested route path
//       component: <Chat />,
//     },
//   ];

//   const location = useLocation();
//   const initialLocation = location.pathname;

//   const [currentLocation, setCurrentLocation] = useState(initialLocation);

//   useEffect(() => {
//     setCurrentLocation(initialLocation);
//   }, [initialLocation]);

//   return (
//     <div className="font-inter">
//       <Routes>
//         <Route path="/" element={<Home />} />
//         <Route path="/login" element={<Login />} />
//         <Route path="/signup" element={<SignUpPage />} />
//         <Route path="/addTeam/:id" element={<AddTeam />} />
//         <Route path="/details/:id" element={<PersonalDetails />} />
//         <Route path="/forgotPassword" element={<ForgotPassword />} />
//         <Route path="/resetNotification" element={<PasswordResetNotification />} />
//         <Route path="/successfulPassword" element={<SuccessfulPassword />} />
//         <Route path="/resetPassword" element={<ResetPassword />} />
//         <Route path="/uploadLogo" element={<UploadLogo />} />
//         <Route path="/continueTeam" element={<ContinueAddTeam />} />
//         <Route path="/verifyEmail" element={<VerifyEmail />} />
//         <Route path="/email_verification_message" element={<VerificationMsg />} />
//         <Route path="/userSetup" element={<UserSetup />} />

//         <Route path="/dashboard" element={<SharedLayout />}>
//           {privateRoute.map((route, index) => (
//             <Route
//               key={index}
//               path={route.path}
//               element={<RouteGuard>{route.component}</RouteGuard>}
//               index={index}
//             />
//           ))}
//           <Route path="createmodelstep1" element={<CreateModelStep1 />} />
//           <Route path="createmodelstep2" element={<CreateModelStep2 />} />
//           <Route path="createmodelstep3_0" element={<CreateModelStep3_0 />} />
//           <Route path="createmodelstep3" element={<CreateModelStep3 />} />
//           <Route path="createmodelstep4" element={<CreateModelStep4 />} />
//           <Route path="createmodelstep5" element={<CreateModelStep5 />} />
//         </Route>

//       </Routes>
//     </div>
//   );
// }

// export default App;

// fall back - old logic
// import { Routes, Route } from "react-router-dom";
// import "./App.css";
// // import Logo from "./components/common/Logo";
// import SharedLayout from "./pages/Dashboard/SharedLayout";
// import Applications from "./pages/Dashboard/ApplicationsPage/Applications";
// import AdminApplication from "./pages/Dashboard/ApplicationsPage/AdminApp/AdminApplication";
// // import EmptyState from "./pages/Dashboard/ApplicationsPage/EmptyState";
// import Settings from "./pages/Dashboard/Settings/Settings";
// import Models from "./pages/Dashboard/Models";
// import Teams from "./pages/Dashboard/TeamsPage/Teams";
// import Dashboard from "./pages/Dashboard/Dashboard/Dashboard";
// import Faq from "./pages/Dashboard/Faq/Faq";
// import Logout from "./pages/Dashboard/Logout";
// import Chat from "./pages/Dashboard/Chat/Chat";
// import SignUpPage from "./pages/Onboarding/SignUpPage";
// import CreateModelStep1 from "./pages/CreateModel/CreateModelStep1";
// import CreateModelStep2 from "./pages/CreateModel/CreateModelStep2";
// import CreateModelStep3 from "./pages/CreateModel/CreateModelStep3";
// import CreateModelStep5 from "./pages/CreateModel/CreateModelStep5";
// import ProfilePage from "./pages/CustomerProfile/ProfilePage";
// import RouteGuard from "./components/RouteGuard";
// import Login from "./components/signUpForm/Login";
// import PersonalDetails from "./components/signUpForm/PersonalDetails";
// import CreateModelStep4 from "./pages/CreateModel/CreateModelStep4";
// import ForgotPassword from "./components/signUpForm/ForgotPassword";
// import Home from "./pages/Onboarding/Home";
// import AddTeam from "./components/signUpForm/AddTeam";
// import SuccessfulPassword from "./components/signUpForm/SuccessfulPassword";
// import PasswordResetNotification from "./components/signUpForm/PasswordResetNotification";
// import ResetPassword from "./components/signUpForm/ResetPassword";
// import UploadLogo from "./components/signUpForm/UploadLogo";
// import ContinueAddTeam from "./components/signUpForm/ContinueAddTeam";
// import VerifyEmail from "./components/signUpForm/VerifyEmail";
// import VerificationMsg from "./components/signUpForm/VerificationMsg";
// import UserSetup from "./components/signUpForm/UserSetup";
// import CreateModelStep3_0 from "./pages/CreateModel/CreateModelStep3_0";
// // import TeamAdminEmptyState from "./pages/Dashboard/TeamsPage/TeamAdminEmptyState";
// import AdminSettingsPage from "./pages/Dashboard/Settings/AdminSettingsPage";
// import ChangePassword from "./pages/Dashboard/Settings/ChangePassword";
// import ChangePasswordNavigation from "./pages/Dashboard/Settings/ChangePasswordNavigation";
// import PasswordTabNavigation from "./pages/Dashboard/Settings/PasswordTabNavigation";
// import store from "./components/common/Store/store";
// import { Provider } from "react-redux";
// import AnalystSettings from "./pages/Dashboard/Settings/AnalystSettingsPage";
// import SuccessfulModal from "./pages/Dashboard/TeamsPage/SuccessfulModal";

// function App() {
//   const privateRoute = [
//     {
//       path: "/dashboard",
//       index: true,
//       component: <Dashboard />,
//     },
//     {
//       path: "/profile/:applicantId",
//       component: <ProfilePage />,
//     },
//     {
//       path: "/applications",
//       component: <AdminApplication />,
//     },
//     {
//       path: "/applications",
//       component: <Applications />,
//     },
//     // {
//     //   path: "/applications",
//     //   component: <EmptyState />,
//     // },
//     {
//       path: "/models",
//       component: <Models />,
//     },
//     {
//       path: "/settings",
//       component: <Settings />,
//     },
//     {
//       path: "/teams",
//       component: <Teams />,
//     },
//     {
//       path: "/faq",
//       component: <Faq />,
//     },
//     {
//       path: "/chat",
//       component: <Chat />,
//     },
//     {
//       path: "/profile/:applicantId",
//       component: (
//         <SharedLayout>
//           <RouteGuard>
//             <ProfilePage />
//           </RouteGuard>
//         </SharedLayout>
//       ),
//     },
//     // {
//     //   path: "/teams",
//     //   component: <TeamAdminEmptyState />,
//     // },
//     // {
//     //   path: "/settings",
//     //   component: <AdminSettingsPage />,
//     // },
//     // {
//     //   path: "/settings",
//     //   component: <AnalystSettings />,
//     // },
//   ];

//   return (
//     <div className="font-inter">
//       <Routes>
//         <Route path="/login" element={<Login />} />
//         <Route path="/addTeam/:id" element={<AddTeam />} />
//         <Route path="/signup" element={<SignUpPage />} />
//         <Route path="/details/:id" element={<PersonalDetails />} />
//         <Route path="/forgotPassword" element={<ForgotPassword />} />
//         <Route path="/home" element={<Home />} />
//         <Route
//           path="/resetNotification"
//           element={<PasswordResetNotification />}
//         />
//         <Route
//           path="/successfulPassword"
//           element={<SuccessfulPassword />}
//         />
//         <Route path="/resetPassword" element={<ResetPassword />} />
//         <Route path="/uploadLogo" element={<UploadLogo />} />
//         <Route path="/continueTeam" element={<ContinueAddTeam />} />
//         <Route path="/verifyEmail" element={<VerifyEmail />} />
//         <Route
//           path="/email_verification_message"
//           element={<VerificationMsg />}
//         />
//         <Route path="/userSetup" element={<UserSetup />} />
//         <Route path="/" element={<SharedLayout />}>
//            {privateRoute.map((route, index) => (
//             <Route
//               key={index}
//               path={route.path}
//               element={route.component}
//               index={index}
//             />
//           ))}
//           <Route path="createmodelstep1" element={<CreateModelStep1 />} />
//           <Route path="createmodelstep2" element={<CreateModelStep2 />} />
//           <Route
//             path="createmodelstep3_0"
//             // eslint-disable-next-line react/jsx-pascal-case
//             element={<CreateModelStep3_0 />}
//           />
//            <Route path="createmodelstep3" element={<CreateModelStep3 />} />
//           <Route path="createmodelstep4" element={<CreateModelStep4 />} />
//         <Route path="createmodelstep5" element={<CreateModelStep5 />} />
//            <Route path="/changePasswordNavigation" element={<ChangePasswordNavigation />} />
//           <Route path="/changePassword" element={<ChangePassword />} />
//            <Route path="/passwordTabNavigation" element={<PasswordTabNavigation />} />
//         </Route>
//       </Routes>
//      </div>
//   );
// }

// export default App;

// Not being used at the moment
// import { BrowserRouter, Routes, Route } from "react-router-dom";
// import "./App.css";
// import Logo from "./components/common/Logo";
// import SharedLayout from "./pages/Dashboard/SharedLayout";
// import Applications from "./pages/Dashboard/ApplicationsPage/Applications";
// import Settings from "./pages/Dashboard/Settings";
// import Models from "./pages/Dashboard/Models";
// import Teams from "./pages/Dashboard/TeamsPage/Teams";
// import Dashboard from "./pages/Dashboard/Dashboard";
// import Faq from "./pages/Dashboard/Faq";
// import Logout from "./pages/Dashboard/Logout";
// import Chat from "./pages/Dashboard/Chat";
// import SignUpPage from "./pages/SignUpPage";
// import CreateModel_1 from "./pages/CreateModel/CreateModel_1";
// import CreateModel_2 from "./pages/CreateModel/CreateModel_2";

// // why wont this work
// // import {
// //   SharedLayout,
// //   Applications,
// //   Settings,
// //   Models,
// //   Teams,
// // } from "./pages/Dashboard";

// function App() {
//   return (
//     <BrowserRouter>
//       <div className="font-inter">
//         <Routes>
//           <Route path="/" element={<SharedLayout />}>
//             <Route index element={<Dashboard />} />
//             <Route path="applications" element={<Applications />} />
//             <Route path="models" element={<Models />} />
//             <Route path="settings" element={<Settings />} />
//             <Route path="teams" element={<Teams />} />
//             <Route path="faq" element={<Faq />} />
//             <Route path="chat" element={<Chat />} />
//             <Route path="logout" element={<Logout />} />
//             {/* <Route path="*" element={<Error />} /> */}
//             <Route path="createmodel_1" element={<CreateModel_1 />} />
//             <Route path="createmodel_2" element={<CreateModel_2 />} />
//           </Route>
//           <Route path="SignUp" element={<SignUpPage />} />

//           {/* <Route path="*" element={<Error />} /> */}
//         </Routes>
//       </div>
//     </BrowserRouter>
//   );
// }

// export default App;
